import type { FileItem, StorageInfo } from '../../../common/schema/schemaType'

// In-memory file storage for prototype
export const filesMem: Record<string, FileItem> = {
  'root': {
    id: 'root',
    name: 'My Files',
    type: 'folder',
    modifiedDate: '2024-11-18T16:00:00Z',
    createdDate: '2024-11-18T16:00:00Z',
    parentId: null,
    path: '/',
    isStarred: false,
    isShared: false
  },
  'documents': {
    id: 'documents',
    name: 'Documents',
    type: 'folder',
    modifiedDate: '2024-11-18T15:30:00Z',
    createdDate: '2024-11-18T15:30:00Z',
    parentId: 'root',
    path: '/Documents',
    isStarred: true,
    isShared: false
  },
  'images': {
    id: 'images',
    name: 'Images',
    type: 'folder',
    modifiedDate: '2024-11-18T14:00:00Z',
    createdDate: '2024-11-18T14:00:00Z',
    parentId: 'root',
    path: '/Images',
    isStarred: false,
    isShared: true
  },
  'videos': {
    id: 'videos',
    name: 'Videos',
    type: 'folder',
    modifiedDate: '2024-11-18T13:00:00Z',
    createdDate: '2024-11-18T13:00:00Z',
    parentId: 'root',
    path: '/Videos',
    isStarred: false,
    isShared: false
  },
  'downloads': {
    id: 'downloads',
    name: 'Downloads',
    type: 'folder',
    modifiedDate: '2024-11-18T12:00:00Z',
    createdDate: '2024-11-18T12:00:00Z',
    parentId: 'root',
    path: '/Downloads',
    isStarred: false,
    isShared: false
  },
  'project-proposal': {
    id: 'project-proposal',
    name: 'Project Proposal.pdf',
    type: 'file',
    size: 2458742,
    modifiedDate: '2024-11-18T10:30:00Z',
    createdDate: '2024-11-17T09:15:00Z',
    parentId: 'documents',
    path: '/Documents/Project Proposal.pdf',
    extension: 'pdf',
    mimeType: 'application/pdf',
    isStarred: true,
    isShared: false
  },
  'meeting-notes': {
    id: 'meeting-notes',
    name: 'Meeting Notes.docx',
    type: 'file',
    size: 1245680,
    modifiedDate: '2024-11-18T11:45:00Z',
    createdDate: '2024-11-17T14:20:00Z',
    parentId: 'documents',
    path: '/Documents/Meeting Notes.docx',
    extension: 'docx',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    isStarred: false,
    isShared: true
  },
  'vacation-photo': {
    id: 'vacation-photo',
    name: 'Vacation Photo.jpg',
    type: 'file',
    size: 3456789,
    modifiedDate: '2024-11-15T16:20:00Z',
    createdDate: '2024-11-15T16:20:00Z',
    parentId: 'images',
    path: '/Images/Vacation Photo.jpg',
    extension: 'jpg',
    mimeType: 'image/jpeg',
    isStarred: true,
    isShared: false
  },
  'presentation-slides': {
    id: 'presentation-slides',
    name: 'Presentation Slides.pptx',
    type: 'file',
    size: 5678912,
    modifiedDate: '2024-11-16T09:30:00Z',
    createdDate: '2024-11-16T09:00:00Z',
    parentId: 'documents',
    path: '/Documents/Presentation Slides.pptx',
    extension: 'pptx',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    isStarred: false,
    isShared: false
  },
  'budget-spreadsheet': {
    id: 'budget-spreadsheet',
    name: 'Budget 2024.xlsx',
    type: 'file',
    size: 987654,
    modifiedDate: '2024-11-17T13:15:00Z',
    createdDate: '2024-11-10T10:00:00Z',
    parentId: 'documents',
    path: '/Documents/Budget 2024.xlsx',
    extension: 'xlsx',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    isStarred: false,
    isShared: true
  }
}

export const storageMem: StorageInfo = {
  totalSpace: 107374182400, // 100GB
  usedSpace: 15728640000,   // 14.6GB
  availableSpace: 91645542400 // 85.4GB
}

// Helper function to generate unique IDs
export function generateId(): string {
  return Math.random().toString(36).substr(2, 9)
}